import React, { FC, useState, useEffect } from "react";

import axios from "axios";

import { User, UserType } from "../../../data";

import Modal from "../../atoms/Modal";

interface UserModal {
  showModal: boolean;
  onClose: () => void;
  user: UserType;
  config: {
    headers: {
      Authorization: string;
    };
  };
  setUser: (user: UserType) => void;
}

const UserModal: FC<UserModal> = ({
  showModal,
  onClose,
  user,
  config,
  setUser,
}) => {
  const [request, setRequest] = useState<UserType>(User);

  useEffect(() => {
    setRequest({ ...user });
  }, [user]);

  async function handleUserEdit() {
    // if there is no changes to the user, close the modal
    if (JSON.stringify(request) === JSON.stringify(user)) {
      onClose();
      return;
    }

    try {
      const { status } = await axios.patch(
        `/api/v1/user/${user.id}`,
        { ...request },
        config,
      );

      if (status !== 200) {
        console.error("Error updating user");
        return;
      }

      setUser({ ...request });

      onClose();
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <Modal {...{ isOpen: showModal, onClose }}>
      <h2>Editar Usuario</h2>
      <div>
        <label>
          <b>Nombre: </b>
          <input
            value={request.firstName}
            onChange={(e) =>
              setRequest((prev) => ({ ...prev, firstName: e.target.value }))
            }
          />
        </label>
        <label>
          <b>Apellido: </b>
          <input
            value={request.lastName}
            onChange={(e) =>
              setRequest((prev) => ({ ...prev, lastName: e.target.value }))
            }
          />
        </label>
        <label>
          <b>Compania: </b>
          <input
            value={request.company?.toLowerCase()}
            onChange={(e) =>
              setRequest((prev) => ({
                ...prev,
                company: e.target.value.toUpperCase(),
              }))
            }
          />
        </label>
      </div>
      <div className="d-flex justify-content-end">
        <button className="btn btn-primary m-1" onClick={handleUserEdit}>
          Modificar
        </button>
        <button className="btn btn-danger m-1" onClick={onClose}>
          Cerrar
        </button>
      </div>
    </Modal>
  );
};

export default UserModal;
